module.exports = __webpack_public_path__ + "static/media/elements_line_end_vertical_red.450a2a71.svg";